import Vue from 'vue';
import i18n from '../i18n'
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import pl from 'vuetify/src/locale/pl';
import en from 'vuetify/src/locale/en';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import { locale } from '@/i18n';

// console.log(pl);

Vue.use(Vuetify);

export const vuetify = new Vuetify({
  lang: {
    locales: { pl, en },
    current: locale,
    t: (key: any, ...params: any) => i18n.t(key, params),
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#000000',
        secondary: '#424242',
        accent: '#000000',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        primary: '#000000',
        secondary: '#424242',
        accent: '#000000',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      }
    }
  }
});
